import React from 'react';

import { countryList } from '../../../../constants/countryList';
// TODO: Fix this. DataTables should not be using SignUp components.
import CustomSelect from '../../../../components/forms/SignUpCompanyDetailsForm/CustomSelect';

const options = countryList.map(({ name, 'alpha-3': alpha3 }) => ({ value: alpha3, text: { text: name } }));
const alpha2Options = countryList.map(({ name, 'alpha-2': alpha2 }) => ({ value: alpha2, text: { text: name } }));

const CountrySelect = (props) => {
  return <CustomSelect {...props} options={options} />;
};

const CountrySelectAlpha2 = (props) => {
  return <CustomSelect {...props} options={alpha2Options} />;
};

export { CountrySelectAlpha2 };

export default CountrySelect;
